import { GetLatestEventsResponseSchema } from '@vy/api-definition';
import { useMutation } from 'react-query';

import { getPrivateApi } from '../../../../services/api';
import type { UseLatestEventsPayload } from '../../../../hooks/requests/use-latest-events/use-latest-events-types';

const PAGE = 0;
const PAGE_SIZE = 100000;

export function useNonPagedEventsFromParams(filterInfo: Omit<UseLatestEventsPayload, 'page' | 'pageSize'>) {
  return useMutation({
    mutationFn: async () => {
      const privateApi = getPrivateApi();
      const response = await privateApi.getLatestEvents({
        ...filterInfo,
        page: PAGE,
        pageSize: PAGE_SIZE,
      });

      return GetLatestEventsResponseSchema.parse(response);
    },
  });
}
